const data = [
  {
    id: 97,
    link: "https://github.com/shivamgupta002/Pizza-Sales-Revenue",
    title: "Pizza Sales Analysis Using SQL",
    desc: "Analyzed 1,000+ sales records to extract key business metrics and insights. Used 10+ advanced SQL queries, joins, grouping, and window functions to calculate revenue, identify top-performing pizzas, and analyze order trends across 5+ tables.",
  },
  {
    id: 98,
    link: "https://github.com/shivamgupta002/Telecom-Customer-Churn-Prediction",
    title: "Telecom Customer Churn Analysis",
    desc: "Explored a telecom dataset to understand churn behavior using tools like Pandas, Seaborn, and Matplotlib. Key findings: 42.32% churn for month-to-month contracts, 32.56% churn for fiber-optic users, and a 13% reduction in churn with automatic payments.",
  },
  {
    id: 99,
    link: "https://github.com/shivamgupta002/Restaurant-Website",
    title: "Restaurant-Website",
    desc: "In this application SignUp and login for restaurant ,restaurant search,food items list and restaurant list for users, add to cart ,user login and SignUp ,order food ,delivery partner assigned to deliver food ,order list for customer,auto detect location ,and many more",
  },
  {
    id: 100,
    link: "https://schoolwebsite002.netlify.app/",
    title: "School Website",
    desc: "I developed a responsive website for Springdale Public School using React.js. It includes sections like Home, About Us, and Academics, with Tailwind CSS styling, Context API state management, and Google Maps integration, showcasing my frontend development skills.",
  },
  {
    id: 101,
    link: "https://github.com/shivamgupta002/Flipkart",
    title: "E-Commerce",
    desc: "In this application You can search Product See Product See discount on product cart option paymentGateway using Your account ",
  },  
  {
    id: 102,
    link: "https://github.com/shivamgupta002/WhatsApp",
    title: "WhatsApp",
    desc: "In this application you can chat with your friend using your gmail account.In this Socket.io ReactJs NodeJs ExpressJs MongoDB ContextApi MaterialUI is used.",
  },
  {
    id: 1,
    link: "https://s-textformatter.netlify.app/",
    title: "Text-formatter",
    desc: "In this application you can modify your data to upperCase, lowerCase, Remove Extra Space from the text, Count the word ,letters present in the box, Average time to read",
  },
  {
    id: 2,
    link: "https://shivam-gupta-speechwriter.netlify.app/",
    title: "Speech To Text Converter",
    desc: "In this application you can convert your voice into text as well as Copied text that you speech",
  },
  // {
  //   id: 3,
  //   link: "https://github.com/shivamgupta002/E-commerce",
  //   title: "E-commerce",
  //   desc: "This is fully Professional E-commerce Website. In this website you can order your product, admin will be able to add,modify and delete product, payment system also included.",
  // },
  // {
  //   id: 4,
  //   link: "https://github.com/shivamgupta002/Employee_Crud",
  //   title: "Employee Details (CRM)",
  //   desc: "In this application you can add your details and it store in database by which you an get your data anytime and modify as well as",
  // },
  // {
  //   id: 5,
  //   link: "https://github.com/shivamgupta002/Book-Store",
  //   title: "Book-Store",
  //   desc: "This application is like a digital Book store management system where you add your books , update price img,and many more",
  // },
  // {
  //   id: 6,
  //   link: "https://github.com/shivamgupta002/DSA",
  //   title: "DSA Problem solved",
  //   desc: "In this I solved many problem of DSA of different competitive Platform and sort in a different folder you can check it out ",
  // },
  // {
  //   id: 10,
  //   link: "https://github.com/shivamgupta002/News",
  //   title: "News",
  //   desc: "In this application you can view latest news with different categories like Sports, Science, Technology, Entrainment, Business etc",
  // },
  {
    id: 11,
    link: "https://s-quiz.netlify.app/",
    title: "Quiz Play",
    desc: "Interactive web quiz app, designed for engagement, featuring diverse quizzes on various topics for a fun and educational experience",
  },

  {
    id: 12,
    link: "https://shivamcalcii.netlify.app/",
    title: "Calculator",
    desc: "I created a web-based calculator application for quick and convenient mathematical calculations, offering user-friendly functionality and accessible from any browser..",
  },
  {
    id: 13,
    link: "https://shivamquote.netlify.app/",
    title: "Quotes",
    desc: "Built a web app that delivers daily inspirational quotes to uplift and motivate users, spreading positivity one click at a time.",
  },
  // {
  //   id: 14,
  //   link: "https://s-dictionary.netlify.app/",
  //   title: "Dictionary Application",
  //   desc: "I developed a user-friendly web-based dictionary application for easy word lookup and definitions, enhancing language comprehension and communication.",
  // },
  // {
  //   id: 15,
  //   link: "https://s-paragraphgenerator.netlify.app/",
  //   title: "Paragraph Generator",
  //   desc: "I've developed a paragraph generator web app for creating concise and informative text. It simplifies content creation with ease.",
  // },
  // {
  //   id: 16,
  //   link: "https://s-emojislider.netlify.app/",
  //   title: "Rating mark",
  //   desc: "I created 'Rating Marker', a user-friendly web app for rating and reviewing products or services, enhancing customer feedback experiences.",
  // },
  {
    id: 17,
    link: "https://s-stopwatch.netlify.app/",
    title: "Stop-Watch",
    desc: "I created a web-based stopwatch app for precise timing and tracking events, enhancing productivity and time management.",
  },
  {
    id: 18,
    link: "https://github.com/shivamgupta002/",
    title: "More",
    desc: "More Projects coming soon",
  },
];
export default data;
